<footer class="modern-footer">
  <div class="footer-container">
    <!-- Privacy Notice -->
    <div class="footer-section">
      <div class="privacy-notice">
        <h4>Privacy & Data Protection</h4>
        <p>
          Your privacy is important to us. We do not save or store any of your content. 
          All calculations and processing are performed directly on your device (client-side) 
          to ensure data privacy. For the purpose of improving our services, we collect 
          limited user experience data, such as analytics and usage patterns, but this does 
          not include your content or personal information.
        </p>
        <p>
          Questions? Contact me at 
          <a href="mailto:sharan&#64;matools.org">sharan&#64;matools.org</a>
        </p>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
      <div class="copyright">
        <span>maTools <i class="bi bi-c-circle"></i> {{date | date : 'yyyy'}}</span>
      </div>
    </div>
  </div>

  <!-- Ad Unit -->
  <div class="ad-container">
    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7186521322171092"
         crossorigin="anonymous"></script>
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-7186521322171092"
         data-ad-slot="5715991022"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
    <script>
         (adsbygoogle = window.adsbygoogle || []).push({});
    </script>
  </div>
</footer>